$(document).ready(function () {
  $(".footer__country__select__header").click(function (evt) {
    evt.preventDefault();
    const footerCountrySelect = $(this).parents(".footer__country__select");
    footerCountrySelect.toggleClass("footer__country__select--active");
  });

  $(document).mouseup(function (e) {
    var container = $(".footer__country__select");
    if (container.has(e.target).length === 0) {
      $(".footer__country__select").removeClass(
        "footer__country__select--active"
      );
    }
  });

  $(".footer__country__select__item").click(function (evt) {
    $(".footer__country__select__item").removeClass(
      "footer__country__select__item--selected"
    );
    $(this).addClass("footer__country__select__item--selected");

    const footerCountrySelectItemWrapper = $(this).find(
      ".footer__country__select__item__wrapper"
    );
    //$('.footer__country__select__value').html(footerCountrySelectItemWrapper.html());
    let footerCountrySelectName = $(this).find(
      ".footer__country__select__name"
    );
    const footerCountrySelectCountry = $(this).find(
      ".footer__country__select__country"
    );

    const footerCountrySelectValueCountry = $(
      ".footer__country__select__value .footer__country__select__country"
    );
    const footerCountrySelectValueName = $(
      ".footer__country__select__value .footer__country__select__name"
    );
    footerCountrySelectValueCountry.attr(
      "src",
      footerCountrySelectCountry.attr("src")
    );
    footerCountrySelectValueCountry.attr(
      "title",
      footerCountrySelectName.text().trim()
    );
    footerCountrySelectValueCountry.attr(
      "alt",
      footerCountrySelectName.text().trim()
    );

    if (footerCountrySelectName.text().trim() == "Россия") {
      footerCountrySelectValueName.text("рус");
    } else {
      footerCountrySelectValueName.text(
        footerCountrySelectName.text().trim().substr(0, 3)
      );
    }

    $(".footer__country__select").removeClass(
      "footer__country__select--active"
    );
  });
});
